import { useState, type ReactNode } from "react"
import Command from "@/v2-ui/command"

type SelectorCommandProps = {
  shouldFilter: boolean
  children: ReactNode
}

function SelectorCommand(props: SelectorCommandProps) {
  const { shouldFilter, children } = props
  const [commandValue, setCommandValue] = useState("")

  return (
    <Command
      shouldFilter={shouldFilter}
      value={commandValue}
      onValueChange={setCommandValue}
    >
      {children}
    </Command>
  )
}

export default SelectorCommand
